import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormBase from '../FormBase';
import Form from './Form';
import { FIELDS } from './validation/fields';
import { makeInitialState } from '../../../helpers/FormHelper';
import { schema } from './validation/schema';

const PreFormGeneric = ({ ...props }) => {
  const { mobile, motiveId, issueForm, issueFormName } = props;
  const [state, setState] = useState({});
  const [data, setData] = useState({});
  const [valid, setValid] = useState(false);

  const handleData = (data) => {
    setData(data);
  };

  const onState = (innerState) => {
    setState(innerState);
  };

  const handleValid = (validity) => {
    setValid(validity);
  };

  return (
    <React.Fragment>
      <FormBase
        mobile={mobile}
        title=""
        form={
          <Form
            state={state}
            onData={handleData}
            valid={valid}
            mobile={mobile}
            motiveId={motiveId}
            issueForm={issueForm}
            issueFormName={issueFormName}
          />
        }
        fields={FIELDS}
        pre
        data={data}
        formName="preForm"
        schema={schema}
        makeInitialState={makeInitialState}
        onState={onState}
        onValid={handleValid}
      />
    </React.Fragment>
  );
};

PreFormGeneric.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  issueForm: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  issueFormName: PropTypes.string,
};

export default PreFormGeneric;
